import React from 'react';

const useFullscreen = () => {
  const isFullscreenSupported = !!document.fullscreenEnabled;
  const [isFullscreen, setIsFullscreen] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  const toggleFullscreen = React.useCallback(async () => {
    if (!document.fullscreenElement) {
      await containerRef.current?.requestFullscreen();
    } else {
      await document.exitFullscreen();
    }
  }, []);

  React.useEffect(() => {
    if (!isFullscreenSupported) return;
    const handleChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', handleChange);
    return () => document.removeEventListener('fullscreenchange', handleChange);
  }, [isFullscreenSupported]);

  return {
    isFullscreen,
    isFullscreenSupported,
    containerRef,
    toggleFullscreen: isFullscreenSupported ? toggleFullscreen : undefined,
  };
};

export default useFullscreen;
